import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { BlockTableContents, BlockTablesContent } from "../../../../../main/blocks/BlockTable/BlockTablesContent";
import AnimateHeight from "react-animate-height";
import { PortableText } from "@portabletext/react";
import styles from "./GraphContext.module.scss";
import { EffektButton } from "../../../EffektButton/EffektButton";
import { Download } from "react-feather";
import { Cumulativedonationstableheaders } from "../../../../../../studio/sanity.types";
export type GraphContextData = {
  description: string;
  detailed_description_label: string;
  detailed_description: any[];
  allow_table: boolean;
  table_label: string;
  table_close_label: string;
  locale?: string;
};
export const GraphContext: React.FC<{
  context: GraphContextData;
  tableContents: BlockTableContents;
}> = t0 => {
  const $ = _c(26);
  const {
    context,
    tableContents
  } = t0;
  const [explenationOpen, setExplenationOpen] = useState(false);
  const [tableDisplayed, setTableDisplayed] = useState(false);
  let t1;
  if ($[0] !== context.description) {
    t1 = <i>{context.description}</i>;
    $[0] = context.description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== explenationOpen) {
    t2 = e => {
      setExplenationOpen(!explenationOpen);
      e.currentTarget.blur();
    };
    $[2] = explenationOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `rotate(${explenationOpen ? "180deg" : "0deg"})`;
  let t4;
  if ($[4] !== t3) {
    t4 = <span style={{
      display: "inline-block",
      transition: "all 200ms",
      transform: t3
    }}>↓</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== context.detailed_description_label || $[7] !== t2 || $[8] !== t4) {
    t5 = <button onClick={t2} className={styles.detailedDescriptionLabel}>{context.detailed_description_label}{" "}{t4}</button>;
    $[6] = context.detailed_description_label;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = explenationOpen ? "auto" : 0;
  let t7;
  if ($[10] !== context.detailed_description) {
    t7 = <PortableText value={context.detailed_description} />;
    $[10] = context.detailed_description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <AnimateHeight height={t6}>{t7}</AnimateHeight>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== context.allow_table || $[16] !== context.table_close_label || $[17] !== context.table_label || $[18] !== tableContents || $[19] !== tableDisplayed) {
    t9 = context.allow_table && <><div className={styles.actions}><button onClick={e_0 => {
          setTableDisplayed(!tableDisplayed);
          e_0.currentTarget.blur();
        }} className={styles.tableButton}>{tableDisplayed ? context.table_close_label : context.table_label}</button>{tableDisplayed && <EffektButton onClick={() => {
          const csv = tableContents.rows.map(_temp2).join("\n");
          const blob = new Blob([csv], {
            type: "text/csv"
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "data.csv";
          a.click();
          URL.revokeObjectURL(url);
        }}>Last ned CSV  <Download size="0.8rem" /></EffektButton>}</div>{tableDisplayed && <BlockTablesContent fixedStyles={{}} config={{
        headers: true
      }} contents={tableContents} />}</>;
    $[15] = context.allow_table;
    $[16] = context.table_close_label;
    $[17] = context.table_label;
    $[18] = tableContents;
    $[19] = tableDisplayed;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t1 || $[22] !== t5 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className={styles.wrapper}>{t1}{t5}{t8}{t9}</div>;
    $[21] = t1;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
function _temp(c) {
  if (!isNaN(Number(c))) {
    return c;
  }
  return `"${c.replace(/"/g, "\"\"")}"`;
}
function _temp2(row) {
  return row.cells.map(_temp).join(",");
}